import { Dropdown } from "components/ui";
import { PLACEMENT } from "components/ui/utils/constant";
import { useEffect, useMemo, useState } from "react";
import { LuClapperboard } from "react-icons/lu";
import { TbDeviceIpadHeart, TbHistoryToggle } from "react-icons/tb";
import { BiSolidMoviePlay } from "react-icons/bi";

const MediaProductTypeDropdown = ({
    post,
    isEditable = true,
    onChange = (media_product_type) => void 0,
    allowedMediaProductTypes = ["FEED", "STORY", "REEL", "SHORT"],
    portal = false
}) => {

    let mediaProductTypeOptions = useMemo(() => [
        {
            id: "FEED",
            title: "Feed",
            description: "Post will appear in your feed",
            icon: <TbDeviceIpadHeart className="text-primary-600 !text-3xl shrink-0" />
        },
        {
            id: "STORY",
            title: "Story",
            description: "Stories will last 24 hours",
            icon: <TbHistoryToggle className="text-purple-500 !text-3xl shrink-0" />
        },
        {
            id: "REEL",
            title: "Reel",
            description: "Video will be posted as Reel",
            icon: <LuClapperboard className="text-fuchsia-600 !text-3xl shrink-0" />
        },
        {
            id: "SHORT",
            title: "Short",
            description: "Video will be posted as YouTube Shorts",
            icon: <BiSolidMoviePlay className="text-red-600 !text-3xl shrink-0" />
        }
    ], []);
    
    const [ mediaProductTypes, setMediaProductTypes ] = useState(mediaProductTypeOptions);
    const mediaProductType = mediaProductTypes?.find(e => e?.id?.toLowerCase() == post?.preferences?.media_product_type?.toLowerCase());

    const network = post?.social_network_type || post?.network;

    useEffect(() => {
        if (!post?.preferences?.media_product_type || !mediaProductTypeOptions?.find(e => e.id == post?.preferences?.media_product_type)) {
            isEditable && onChange(mediaProductTypes?.[0]?.id);
        }
    }, []);

    useEffect(() => {
        // Find by id, not index — the list may already be filtered down to
        // the allowed types when the network changes on a live instance.
        if (network == "instagram") {
            let _mediaProductTypes = [...mediaProductTypes];
            const reel = _mediaProductTypes.find(e => e?.id == "REEL");
            if (reel) reel.description = "Video Reels will only appear in the Reels section";
            setMediaProductTypes(_mediaProductTypes)
        } else if (network == "youtube") {
            let _mediaProductTypes = [...mediaProductTypes];
            const short = _mediaProductTypes.find(e => e?.id == "SHORT");
            if (short) short.description = "Vertical videos optimized for mobile viewing";
            setMediaProductTypes(_mediaProductTypes)
        }
    }, [network]);

    useEffect(() => {
        setMediaProductTypes(mediaProductTypeOptions?.filter(e => allowedMediaProductTypes?.includes(e?.id)));
    }, [JSON.stringify(allowedMediaProductTypes)]);

    return (
        <Dropdown
            placement={PLACEMENT.BOTTOM_START}
            parentClassName="w-full"
            menuClass={`w-auto ${portal ? "" : "w-full"} p-0 overflow-y-auto`}
            portal={portal}
            disabled={!isEditable}
            renderTitle={
                <div className={`w-full !p-4 border-b border-tertiary-100 dark:border-gray-700 cursor-pointer ${isEditable && `hover:bg-secondary-200 dark:hover:bg-gray-700`}`}>
                    <div className='flex items-center gap-2.5'>
                        {mediaProductType?.icon}
                        <div className="flex flex-col w-full overflow-hidden">
                            <b className="font-black text-tertiary-700 dark:text-gray-200">{mediaProductType?.title}</b>
                            <small className="text-xs font-normal w-full whitespace-nowrap overflow-hidden text-ellipsis">{mediaProductType?.description}</small>
                        </div>
                    </div>
                </div>
            }
        >
            {mediaProductTypes?.map((_mediaProductType, key) => (
                <Dropdown.Item key={key} onClick={
                    _mediaProductType?.id?.toLowerCase() != post?.preferences?.media_product_type?.toLowerCase() 
                        ? () => { onChange(_mediaProductType?.id); }
                        : undefined
                    } className={`flex items-center gap-2.5 py-2 px-4 ${mediaProductType?.id == _mediaProductType?.id && `bg-primary-200 dark:bg-primary-900`}`}>
                    {_mediaProductType?.icon}
                    <div className="flex flex-col flex-1">
                        <b>{_mediaProductType?.title}</b>
                        <small className="font-normal">{_mediaProductType?.description}</small>
                    </div>
                </Dropdown.Item>
            ))}
        </Dropdown>
    )
}

export default MediaProductTypeDropdown;